import AppStack from "./AppStack";

function App() {
  return <AppStack />;
}

export default App;
